// extracted by mini-css-extract-plugin
export default {"container":"WorkersCompForm_container__lswmC"};